import * as z from "zod";

export const createStripeConnectedAccount = {
  name: "createStripeConnectedAccount" as const,
  input: z.any(),
  output: z.object({ connectedAccountId: z.string() }),
};
